import React, { Component } from "react";
import { Grid, Box, Typography } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";

import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  getLastDayofMonthofGivenDate,
  get_FirstDate_of_Given_YMD_Date,
  validatedate_min_max,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchGSTDetails, fetchGSTDetailsformail } from "./API";
import ExcelJS from "exceljs";
import CtCmb from "./CustomTool/CtCmb";
import DownloadLink from "./DownloadLink";
import CtTxt from "./CustomTool/CtTxt";

import { apiURL } from "./API";

class ExcelGSTR1 extends Component {
  state = {
    fileUrl: "",
    fileName: "GSTR-1 Excel",
    formData: {
      cmbYear: "",
      txtmail: "",
    },
    isFileGenerated: false,
    dataLoadStatus: true,
    ARD: null,

    YearList: [
      { vac_year: "Apr " + localStorage.getItem("ACY") },
      { vac_year: "May " + localStorage.getItem("ACY") },
      { vac_year: "Jun " + localStorage.getItem("ACY") },
      { vac_year: "Jul " + localStorage.getItem("ACY") },
      { vac_year: "Aug " + localStorage.getItem("ACY") },
      { vac_year: "Sep " + localStorage.getItem("ACY") },
      { vac_year: "Oct " + localStorage.getItem("ACY") },
      { vac_year: "Nov " + localStorage.getItem("ACY") },
      { vac_year: "Dec " + localStorage.getItem("ACY") },
      { vac_year: "Jan " + (parseInt(localStorage.getItem("ACY")) + 1) },
      { vac_year: "Feb " + (parseInt(localStorage.getItem("ACY")) + 1) },
      { vac_year: "Mar " + (parseInt(localStorage.getItem("ACY")) + 1) },
    ],
  };

  //#region Component
  componentDidMount() {
    // document.title = "AccountSoftware : GSTR-1";
    this.props.setActiveMenu("ExcelGSTR1");
    this.onFormLoad();
  }
  //#endregion Component

  //#endregion handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  //#region handle

  //#region function

  getSumOfRow = (rows, column) => {
    let Sum = 0;
    rows.map((row) => {
      Sum += Number(row[column]);
    });
    return Sum;
  };

  getMonthName = (month) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return monthNames[month];
  };

  onFormLoad = () => {
    let monthNumber = new Date().getMonth(),
      Year = new Date().getFullYear(),
      monthName = this.getMonthName(monthNumber - 1);

    let cmbYear =
      monthName === "Mar"
        ? ""
        : monthName === "Jan" || monthName === "Feb"
          ? monthName + " " + (Year + 1)
          : monthName + " " + Year;
    this.setState({
      formData: {
        ...this.state.formData,
        cmbYear,
      },
    });
  };

  // validateYear = (isFullExcel) => {
  //   let result = false;
  //   if (this.state.formData.cmbYear.length <= 0) {
  //     this.props.toastErrorMsg("Select Year", "cmbYear");
  //   } else if (isFullExcel && this.state.formData.txtmail.length <= 0) {
  //     this.props.toastErrorMsg("Enter Email Id", "txtmail");
  //   } else {
  //     result = true;
  //   }
  //   return result;
  // };

  validateYear = (isFullExcel) => {
    let result = false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (this.state.formData.cmbYear.length <= 0) {
      this.props.toastErrorMsg("Select Year", "cmbYear");
    } /* else if (isFullExcel) {
      if (this.state.formData.txtmail.length <= 0) {
        this.props.toastErrorMsg("Enter Email Id", "txtmail");
      } else if (!emailRegex.test(this.state.formData.txtmail)) {
        this.props.toastErrorMsg("Enter a valid Email Id", "txtmail");
      } else {
        result = true;
      }
    }  */ else {
      result = true;
    }

    return result;
  };

  generateExcel = () => {
    if (this.validateYear(true)) {
      this.props.notifyProcessing();
      const reqData = {
        Op: "GSTR-1-Full",
        bint_acid: localStorage.getItem("acid"),
        vac_monthyear: this.state.formData.cmbYear,
        emailid: this.state.formData.txtmail,
        fullExcel: "Yes",
      };
      fetchGSTDetailsformail(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          // let fileUrl = res.data.DownloadLink;
          // this.setState(
          //   {
          //     fileUrl,
          //     isFileGenerated: true,
          //   },
          //   () => {
          //     // console.log("this.state", this.state);
          //   }
          // );
        })
        .catch((error) => {
          console.log("Unknown error occurred in getLedgerList.", error);
        });
    }
  };

  mail = () => {
    if (this.validateYear(true)) {
      this.props.notifyProcessing(); // Notify that processing is ongoing
      const reqData = {
        Op: "Email_GST",
        emailid: this.state.formData.txtmail, // Email from the form
      };

      fetchGSTDetails(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
        })
        .catch((error) => {
          console.log("Unknown error occurred while sending email.", error);
        });
    }
  };

  generateExcel_short = () => {
    if (this.validateYear()) {
      this.props.notifyProcessing();
      const reqData = {
        Op: "GSTR1",
        bint_acid: localStorage.getItem("acid"),
        vac_monthyear: this.state.formData.cmbYear,
      };
      fetchGSTDetails(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          //   let fileUrl = res.data.DownloadLink;
          //   this.setState(
          //     {
          //       fileUrl,
          //       isFileGenerated: true,
          //     },
          //     () => {
          //       // console.log("this.state", this.state);
          //     }
          //   );
          // })
          // .catch((error) => {
          //   console.log("Unknown error occurred in getLedgerList.", error);

          if (res.data.msgType === "success" && res.data.DownloadLink) {
            this.setState({
              fileUrl: res.data.DownloadLink,
              isFileGenerated: true, // Show link
            });
          } else {
            this.setState({
              fileUrl: "",
              isFileGenerated: false, // Hide link
            });
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in getLedgerList.", error);
          this.setState({
            fileUrl: "",
            isFileGenerated: false, // Hide link on error
          });
        });
    }
  };

  // //#endregion function

  render() {
    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
          spacing={2}
        >
          <Grid item>
            <CtCmb
              id="cmbYear"
              label="Year"
              items={this.state.YearList}
              value={this.state.formData.cmbYear}
              handleOnChange={this.handleOnChange}
              width={170}
              maxLength={20}
              colID="vac_year"
            />
          </Grid>

          {/* <Grid item>
            <CtTxt
              id="txtmail"
              value={this.state.formData.txtmail}
              label="Email*"
              handleOnChange={this.handleOnChange}
              width={250}
              maxLength={100}
            />
          </Grid> */}
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          {/* <Grid item>
            <CtBtn
              label="Generate Full Excel"
              onClick={this.generateExcel}
              iconName={"excel"}
            />
          </Grid> */}

          <Grid item>
            <CtBtn
              label="Generate Short Excel"
              onClick={this.generateExcel_short}
              iconName={"excel"}
            />
          </Grid>

          {/* <Grid item>
            <CtBtn label="Mail" onClick={this.mail} />
          </Grid> */}

          {this.state.isFileGenerated && (
            <Grid item>
              <DownloadLink
                fileUrl={apiURL + this.state.fileUrl}
                fileName={this.state.fileName}
              />
            </Grid>
          )}
        </Grid>
        <br />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HoCtToastContainer(withRouter(ExcelGSTR1)));
